import {
  Dumbbell,
  Video,
  PlayCircle,
  Activity,
  Music,
  HeartPulse,
  Smile,
} from "lucide-react";

const services = [
  {
    title: "Weight Loss Programs",
    description:
      "Targeted plans combining strength, cardio & flexibility for sustainable results.",
    icon: Dumbbell,
    color: "bg-blue-100 text-blue-600",
  },
  {
    title: "Live Trainer Sessions",
    description:
      "Interactive classes where trainers see you, guide you, and keep you motivated.",
    icon: Video,
    color: "bg-green-100 text-green-600",
  },
  {
    title: "Recordings of Live Workouts",
    description:
      "Can’t join live? Pick your time & complete your daily fitness regime at your convenience.",
    icon: PlayCircle,
    color: "bg-yellow-100 text-yellow-600",
  },
  {
    title: "Power Yoga & Meditation",
    description: "Improve flexibility, balance & calm your mind.",
    icon: HeartPulse,
    color: "bg-purple-100 text-purple-600",
  },
  {
    title: "Functional Fitness",
    description:
      "No heavy machines—just bodyweight, bands, and smart routines.",
    icon: Activity,
    color: "bg-orange-100 text-orange-600",
  },
  {
    title: "Dance Zumba",
    description:
      "Fun, energetic dance workouts to burn calories and stay active.",
    icon: Music,
    color: "bg-pink-100 text-pink-600",
  },
  {
    title: "Physiotherapy Support",
    description:
      "Personalized guidance from experts to aid in physical recovery and care.",
    icon: HeartPulse,
    color: "bg-red-100 text-red-600",
  },
  {
    title: "Mindset Transformation",
    description:
      "A holistic approach for your overall balanced health and happiness.",
    icon: Smile,
    color: "bg-teal-100 text-teal-600",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 bg-gradient-to-b from-white to-gray-50">
      {/* Header */}
      <div className="text-center mb-16">
        <h4 className="text-orange-500 font-semibold uppercase tracking-wide">
          Services We Offer
        </h4>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-3">
          Unlock Your Exclusive Benefits
        </h2>
        <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
          Discover a wide range of programs and expert guidance designed to help
          you achieve your health, fitness, and wellness goals.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
        {services.map((service, index) => (
          <div
            key={index}
            className="flex items-center p-6 rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
          >
            {/* Icon wrapper - uniform size */}
            <div
              className={`flex-shrink-0 w-16 h-16 flex items-center justify-center rounded-xl ${service.color} shadow-sm`}
            >
              <service.icon size={28} />
            </div>

            {/* Text */}
            <div className="ml-5 flex-1">
              <h3 className="text-lg font-semibold text-gray-900">
                {service.title}
              </h3>
              <p className="text-gray-600 mt-1 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
